<h1 mat-dialog-title>{{ data.title }}</h1>

<div mat-dialog-content class="preview-content">
    <img
        *ngIf="!loadFailed"
        [src]="data.imageUrl"
        alt="Vorschau der Vorlage"
        (error)="onImageError()"
    />
    <p *ngIf="loadFailed" class="preview-fallback">Vorschau nicht verfügbar</p>
</div>

<div mat-dialog-actions align="end">
    <button mat-flat-button color="accent" type="button" (click)="close()">Schließen</button>
</div>
